export default function timeAgo(updatedAt) {
  if (!updatedAt) return 'Invalid date';

  const fixedUpdatedAt = updatedAt?.split('.')[0] + 'Z';
  const now = new Date();
  const updatedDate = new Date(fixedUpdatedAt);
  const differenceInSeconds = Math.floor((now - updatedDate) / 1000);

  if (differenceInSeconds < 60) {
    return `${differenceInSeconds} sec${
      differenceInSeconds !== 1 ? 's' : ''
    } ago`;
  }

  const minutes = Math.floor(differenceInSeconds / 60);
  if (minutes < 60) {
    return `${minutes} min${minutes !== 1 ? 's' : ''} ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  }

  const days = Math.floor(hours / 24);
  return `${days} day${days !== 1 ? 's' : ''} ago`;
}
